'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'fire';
var width = 448;
var height = 512;
var aliases = [128293];
var unicode = 'f06d';
var svgPathData = 'M239.7 109.4C229 96.1 208.3 75.1 189 56.4c-4.6-4.5-9-8.7-13.1-12.6c-1.6 1.5-3.2 3.1-4.9 4.8c-15.9 15.7-37 38-58.1 64.1c-21.1 26.2-41.7 55.7-56.8 85.8C40.8 228.9 32 258.2 32 284.5C32 394.9 116.6 480 224 480c106.2 0 192-85.1 192-195.5c0-47.2-28.4-99.5-61.5-143.3c-16-21.2-32.1-39-44.3-51.6c0 0 0 0 0 0c-9.6 8.3-17.3 15.7-20.1 19.3l-24.8 32.5-25.5-31.9zM0 284.5C0 152 176 0 176 0s38.4 35.3 67.1 65.3c8.5 8.9 16.1 17.2 21.6 24.1c4.7-6.1 13.8-14.7 22.9-22.6C299.9 56.1 312 46.6 312 46.6s136 121.4 136 237.9C448 412.2 348.2 512 224 512C98.4 512 0 412.1 0 284.5zM187.7 182c2.9 3.6 24.7 31.3 45.7 58L262 276.4l.8 1 37.9-44 13-15.1 12 15.9c5.1 6.8 8.4 13.5 11.2 18.9l.1 .1c28.6 52.6 16.3 120.4-33.1 154.9l-.3 .2s0 0 0 0C279.8 424 254.3 432 225.7 432c-35 0-67.4-11.3-91.3-33.1C110.3 377 96 345.3 96 306.8c0-20.5 6.5-39.1 18-58.6c11.2-19.2 27.8-40.5 48.8-66.2l12.5-15.4L187.7 182zm62 130.5s0 0 0 0s0 0 0 0c0 0 0 0 0-.1l-.2-.2-.7-.9-2.6-3.3-9.3-11.8-28.6-36.4c-12.1-15.4-24.4-31-33.2-42.2c-14.7 18.5-25.7 33.4-33.5 46.6C132 280.8 128 293.7 128 306.8c0 30.1 11 53 28 68.5C173.1 391 197.5 400 225.7 400c22 0 41.3-6 59.8-18.2c33.7-23.7 44.3-71.2 24.7-110.4L274.4 313l-12.7 14.8-12-15.3 12.6-9.9c-12.6 9.9-12.6 9.9-12.6 9.9z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFire = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;